import type { IdentificationDocumentType } from '@/modules/shared/types/IdentificationDocumentType.ts';
import type customerDataEvents from '@/modules/shared/utils/gtmEvents/events/shippingEvents.ts';

export type EventInteractiveTag = CustomerDataEventInteractiveTags | string;
export interface GtmEvent {
  'event-interactive-category': CustomerDataEventInteractiveCategories;
  'event-interactive-accion'?: CustomerDataEventInteractiveActions;
  'event-interactive-tag'?: EventInteractiveTag;
  event?: string;
  documentType?: IdentificationDocumentType;
}

export interface GtmEventWithGroup extends GtmEvent {
  'event-interactive-grupo_despacho'?: string;
}
export interface GtmEventWithLocalization extends GtmEvent {
  'event-interactive-comuna'?: string;
  'event-interactive-region'?: string;
}

export interface GtmEventWithIdentification extends GtmEvent {
  i1?: string;
  i2?: string;
  'event-interactive-rut'?: string;
  'event-interactive-dni'?: string;
  'event-interactive-tipoLogin'?: string;
}

export type CustomerDataEvent =
  | GtmEvent
  | GtmEventWithGroup
  | GtmEventWithLocalization
  | GtmEventWithIdentification;

export type CustomerDataEventsType = Record<string, CustomerDataEvent>;

export type CustomerDataEventKeys = keyof typeof customerDataEvents;

export type SendGtmEvent = {
  event: CustomerDataEventKeys;
  extraFields?: Partial<CustomerDataEvent>;
};

export enum CustomerDataEventInteractiveCategories {
  Checkout = 'Checkout pre shipping',
  UserIdentify = 'Identificación usuario'
}

export enum CustomerDataEventInteractiveActions {
  Click = 'Click',
  ClickLink = 'Click enlace',
  ClickCreateAccount = 'Clic botón Crear cuenta',
  ContinueAsGuest = 'Continuar guest'
}

export enum CustomerDataEventInteractiveTags {
  LogIn = 'Iniciar sesión',
  CreateAccount = 'Crear cuenta',
  Edit = 'Editar',
  ContinueWithPayment = 'Continuar con el pago',
  GuestUser = 'usuario guest'
}

export enum CustomerDataEventInteractiveTipoLogin {
  Guest = 'Guest'
}
